import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_STATES_ATTEMPT,
  GET_STATES_SUCCESS,
  GET_STATES_FAILURE,
} from "../constants";

// getStates actions
const getStatesAttempt = () => ({
  type: GET_STATES_ATTEMPT,
});

const getStatesSuccess = (payload: any) => ({
  type: GET_STATES_SUCCESS,
  payload,
});

const getStatesFailure = (error: string) => ({
  type: GET_STATES_FAILURE,
  payload: {
    error,
  },
});

export const getStatesRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
  dispatch(getStatesAttempt());

  const params2 = {
    entity: "states",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => res.data)
    .then((payload) => {
      dispatch(getStatesSuccess(payload));
    })
    .catch((error) => {
      dispatch(getStatesFailure(error.message));
    });
};
